module.exports = __webpack_public_path__ + "assets/corekees-nl.de1bf62a.svg";